import { GET, POST, UPLOAD_FILE } from '../apiController';

const BASE = '/api/getstream';

// User token (ensures Stream user exists and token persisted)
export function registerStreamUser() {
  return POST(`${BASE}/users/register`, {});
}

// Messages
export function getChannelMessagesApi({ channelType = 'messaging', channelId, limit = 30, offset = 0 }) {
  // backend returns full list; keep params optional for backward compatibility
  return GET(`${BASE}/groups/${channelType}/${channelId}/messages`, { limit, offset });
}

export function getChannelUnreadApi({ channelType = 'messaging', channelId }) {
  return GET(`${BASE}/groups/${channelType}/${channelId}/unread`);
}

export function markChannelReadApi({ channelType = 'messaging', channelId }) {
  return POST(`${BASE}/groups/${channelType}/${channelId}/read`, {});
}

export function sendChannelMessageApi({ channelType = 'messaging', channelId, text, attachments = [] }) {
  return POST(`${BASE}/groups/${channelType}/${channelId}/messages`, { text, attachments });
}

export function replyToMessageApi({ channelType = 'messaging', channelId, messageId, text, attachments = [] }) {
  return POST(`${BASE}/groups/${channelType}/${channelId}/messages/${messageId}/reply`, { text, attachments });
}

export function deleteMessageApi({ messageId, channelId }) {
  return POST(`${BASE}/messages/delete`, { messageId, channelId });
}

export function editMessageApi({ messageId, channelId, text }) {
  return POST(`${BASE}/messages/edit`, { messageId, channelId, text });
}

export function uploadChannelMediaMessageApi(
  { channelType = 'messaging', channelId, upload_type, text = '' },
  file,
  onProgress
) {
  const formData = new FormData();
  formData.append('file', file);
  formData.append('upload_type', upload_type);
  formData.append('text', text);
  return UPLOAD_FILE(`${BASE}/groups/${channelType}/${channelId}/messages/upload`, formData, {}, onProgress);
}

